// extracted by mini-css-extract-plugin
module.exports = {"alert":"notificationmenuitem_alert__1yIDV","item":"notificationmenuitem_item__3jE0u"};